import { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { extractData } from '../Api/Connection/Connection'
import { TestTokenResponse } from '../Api/models'
import { testUserToken } from '../Api/Api'
import { useNavigate } from 'react-router-dom'

export const useConnector = () => {
    const navigate = useNavigate()
    const [connecting, setConnecting] = useState(false)
    const [connectionStatus, setConnectionStatus] = useState(false)
    const initialized = useRef(false)

    const handleExtractData = useCallback(async () => {
        if (connecting || connectionStatus) return;
        setConnecting(true)
        toast.loading('Conectando con la plataforma...')
        const result: TestTokenResponse = await testUserToken();
        if (result?.data?.status) {

            setConnectionStatus(true)
            toast.dismiss()
            toast.success('Conectado con la plataforma.')
            return;
        }

        try {
            let result = await extractData()
            if (result) {
                toast.dismiss()
                toast.success('Conectado con la plataforma.')
                setConnectionStatus(true)
            } else {
                if (result?.status === 403) {
                    toast.dismiss()
                    navigate('/login')
                }
                toast.dismiss()
                toast.error('Error al conectar con la plataforma.')
                setConnectionStatus(false)
            }

        } catch (error) {
            toast.dismiss()
            console.log(error)
            toast.error('Error al conectar con la plataforma.')
        } finally {
            setConnecting(false)
        }
    }, [connecting, connectionStatus])

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;

            handleExtractData();
        }
    }, [handleExtractData])

    return {
        connectionStatus,
        connecting,
        handleExtractData
    }
}
